import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ILogIntegracionSoflex } from 'modelos/src';
import { firstValueFrom } from 'rxjs';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { LogIntegracionSoflexService } from '../log-integracion-soflex.service';

export interface DetalleLogSoflexData {
  id: string;
  clienteNombre?: string;
}

@Component({
  selector: 'app-detalle-log-integracion-soflex',
  templateUrl: './detalle-log-integracion-soflex.component.html',
  styleUrls: ['./detalle-log-integracion-soflex.component.scss'],
  standalone: false,
})
export class DetalleLogIntegracionSoflexComponent implements OnInit {
  data = inject<DetalleLogSoflexData>(MAT_DIALOG_DATA);
  private service = inject(LogIntegracionSoflexService);
  private helper = inject(HelperService);

  public loading = true;
  public error?: string;
  public log?: ILogIntegracionSoflex;

  public get host(): string {
    try {
      return this.log?.requestUrl ? new URL(this.log.requestUrl).host : '';
    } catch {
      return '';
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public headers(h?: Record<string, any>): { key: string; value: any }[] {
    return Object.entries(h || {}).map(([key, value]) => ({ key, value }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public copiar(dato: any): void {
    const texto =
      typeof dato === 'string' ? dato : JSON.stringify(dato, null, 2);
    navigator.clipboard.writeText(texto ?? '');
    this.helper.notifSuccess('Copiado al portapapeles');
  }

  async ngOnInit(): Promise<void> {
    try {
      this.log = await firstValueFrom(this.service.getById(this.data.id));
    } catch (err) {
      this.error = (err as Error)?.message || 'No se pudo cargar el log';
    } finally {
      this.loading = false;
    }
  }
}
